import { useCallback } from "react";
import { useAuth } from "@clerk/react";
import { api } from "@/lib/api";

export function useAdminApi() {
  const { getToken } = useAuth();
  return useCallback(
    async (method, url, data, config = {}) => {
      const token = await getToken();
      const res = await api.request({ method, url, data, ...config, headers: { ...(config.headers || {}), Authorization: `Bearer ${token}` } });
      return res.data;
    },
    [getToken]
  );
}

export const saveBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
